module.exports = __webpack_public_path__ + "static/media/development-tenis.4b72fc00.png";